import React from 'react';
import styled from 'styled-components';
import { hexToRgba } from '@mrkt/features/color-conversion';
import { IconArrowRight, Type, screenMdMin, screenSmMax, spacer16 } from '@spotify-internal/encore-web';
import { Link, ButtonTertiaryAsLink, fadeInAnimation, HeadlineWithSupertextComponent, withAnimationContext, DELAYS } from '../../ui';
import { useT } from '@mrkt/features/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FAQLinks = styled.div.withConfig({
  displayName: "FAQLinksModule__FAQLinks",
  componentId: "sc-1qf0l61-0"
})(["background:", ";color:", ";display:flex;align-items:flex-start;@media (max-width:", "){flex-direction:column;justify-content:center;padding-top:0;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.box.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.box.text;
}, screenSmMax);
var Left = styled.div.withConfig({
  displayName: "FAQLinksModule__Left",
  componentId: "sc-1qf0l61-1"
})(["display:flex;flex-direction:column;width:100%;padding:0;"]);
var Right = styled.div.withConfig({
  displayName: "FAQLinksModule__Right",
  componentId: "sc-1qf0l61-2"
})(["display:flex;flex-direction:column;width:100%;padding:0;ul{list-style:none;li{padding-top:", ";padding-bottom:", ";&:not(:first-child):not(:last-child){border-top:1px solid ", ";}}}"], spacer16, spacer16, function (_ref3) {
  var theme = _ref3.theme;
  return hexToRgba(theme.box.text, 0.25);
});
var AllFAQLink = styled(ButtonTertiaryAsLink).withConfig({
  displayName: "FAQLinksModule__AllFAQLink",
  componentId: "sc-1qf0l61-3"
})(["padding:0;color:", ";&:hover:not(:focus):not(:disabled){color:", ";}svg{vertical-align:-3px;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.box.text;
}, function (_ref5) {
  var theme = _ref5.theme;
  return hexToRgba(theme.box.text, 0.25);
});
var FAQList = withAnimationContext(styled.ul.withConfig({
  displayName: "FAQLinksModule__FAQList",
  componentId: "sc-1qf0l61-4"
})(["", ";padding-left:0px;"], fadeInAnimation(DELAYS.THIRD)));
var FAQ = styled(Type.p).attrs({
  variant: Type.body1
}).withConfig({
  displayName: "FAQLinksModule__FAQ",
  componentId: "sc-1qf0l61-5"
})(["color:", ";padding:0px;&:hover:not(:focus):not(:disabled){color:", ";}@media (min-width:", "){text-align:left;justify-content:flex-end;width:100%;}@media (max-width:", "){width:100%;align-items:center;}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.box.text;
}, function (_ref7) {
  var theme = _ref7.theme;
  return hexToRgba(theme.box.text, 0.25);
}, screenMdMin, screenSmMax);
var TRACK_CAT = 'module-faqLinks';
export var FAQLinksModule = /*#__PURE__*/React.forwardRef(function (_ref8, ref) {
  var _ref8$supertext = _ref8.supertext,
      supertext = _ref8$supertext === void 0 ? '' : _ref8$supertext,
      _ref8$headline = _ref8.headline,
      headline = _ref8$headline === void 0 ? '' : _ref8$headline,
      _ref8$faqs = _ref8.faqs,
      faqs = _ref8$faqs === void 0 ? [] : _ref8$faqs;
  var t = useT();
  return /*#__PURE__*/_jsxs(FAQLinks, {
    ref: ref,
    children: [/*#__PURE__*/_jsx(Left, {
      children: /*#__PURE__*/_jsx(HeadlineWithSupertextComponent, {
        supertext: supertext,
        headline: headline
      })
    }), /*#__PURE__*/_jsx(Right, {
      children: /*#__PURE__*/_jsxs(FAQList, {
        children: [faqs.map(function (faq) {
          return /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(Link, {
              track: [TRACK_CAT, "FAQ Link - ".concat(faq.question)],
              href: "/help/article/".concat(faq.urlSlug),
              children: /*#__PURE__*/_jsx(FAQ, {
                children: faq.question
              })
            })
          }, faq.id);
        }), /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsxs(AllFAQLink, {
            href: "/help",
            track: [TRACK_CAT, 'All FAQ Link'],
            children: [t('FRODOR_SEE_ALL_FAQS', 'See all FAQs', 'link to the help center containing frequently asked questions'), /*#__PURE__*/_jsx(IconArrowRight, {
              iconSize: 16,
              "aria-hidden": true
            })]
          })
        })]
      })
    })]
  });
});